export function callAll<T>(...fs: Array<((...args: Array<T>) => void) | undefined>): (...args: Array<T>) => void {
  return (...args: Array<T>) => {
    fs.map(f => f && f(...args));
  };
}
export function waitUntil(condition: () => boolean, checkInterval = 100) {
  return new Promise<void>(resolve => {
    const interval = setInterval(() => {
      if (!condition()) return;
      clearInterval(interval);
      resolve();
    }, checkInterval);
  });
}
